import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import { usePayrollContextlessPolicies } from 'modules/payroll_bundle/hooks/usePayrollContextlessPolicies'
import IncidencesPage from 'modules/payroll_bundle/pages/IncidencesPage'

const GuardedIncidencesPage = () => {
  const { loading, canManagePayrollIncidences } = usePayrollContextlessPolicies()

  if (loading) return null

  return (
    <AuthorizeUser authorizeFn={() => canManagePayrollIncidences}>
      <IncidencesPage />
    </AuthorizeUser>
  )
}

export default GuardedIncidencesPage
